<template>
    <div :class="breadcrumbClass">
      <ul class="flex flex-wrap items-center">
         
        <li class="inline-flex items-end">
          <router-link to="/">
            <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
          </router-link>
          <span class="breadcrumb-separator mx-2">
            <feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" />
          </span>
        </li>
  
        
        <li v-for="(link, index) in computedBreadcrumbs.slice(1, -1)" :key="index" class="inline-flex items-center">
          <router-link v-if="typeof link.url === 'string'" :to="link.url">
            {{ link.title }}
          </router-link>
          <router-link v-else-if="typeof link.url === 'function'" :to="getLinkUrl(link.url)">
            {{ link.title }}
          </router-link>
          <span class="text-primary cursor-default" v-else>
            {{ link.title }}
          </span>
          <span class="breadcrumb-separator mx-2 flex items-start">
            <feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" />
          </span>
        </li>
  
        
        <li class="inline-flex">
          <span v-if="computedBreadcrumbs.slice(-1)[0].active" class="cursor-default">
            {{ computedBreadcrumbs.slice(-1)[0].title }}
          </span>
        </li>
      </ul>
    </div>
  </template>
  
<script>
export default {
  name: 'vx-breadcrumb',
  props: {
    route: {
      type: Object,
      required: true
    },
    isRTL: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    breadcrumbClass () {
      return 'vx-breadcrumb' 
    },
    computedBreadcrumbs () {
      return this.route.meta.breadcrumb.map(link => {
        if (typeof link.url === 'function') {
          return {
            ...link,
            url: this.getLinkUrl(link.url) 
          }
        }
        return link
      })
    }
  },
  methods: {
    getLinkUrl (urlFunction) {
      try {
        return urlFunction(this.route)
      } catch (e) {
        console.error('Error computing breadcrumb URL:', e)
        return '#' 
      }
    }
  }
}
</script>
  